module.exports = "<p>\n  edit-new-testing-form works!\n</p>\n"